import { useEffect, useState } from "react";

import { EntityAttribute } from "shared/api/api";

import { ContextName, GroupByRelationIDValues } from "./types";
import { getAllGroupByRelationIDValues } from "./utils";

export const useAllGroupByRelationIDValues = (
  attributesByContext: Record<ContextName, EntityAttribute[]>
) => {
  const [value, setValue] = useState<GroupByRelationIDValues>(
    {} as GroupByRelationIDValues
  );

  useEffect(() => {
    const fetchValues = async () => {
      const values = await getAllGroupByRelationIDValues(attributesByContext);
      setValue(values);
    };

    fetchValues();
  }, [attributesByContext]);

  return value;
};
